<template>
  <div class="zyc-charts-table-content">
    <div v-if="isLoading" class="el-loading-mask" style="height:calc(100% - 45px);margin-top:45px;">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg><!----></div>
    </div>
    <table class="zyc-charts-table" cellpadding="0" cellspacing="0">
      <thead>
      <tr>
        <slot></slot>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(i,index) in data" :class="i.isSelect ? 'zyc-charts-table-active':'' " @click="trClick(i,index)">
        <template v-for="(val,key) in i">
          <td v-if="key == 'name'">
            <div style="width:200px;float:left;margin-right:30px;margin-bottom: 5px" class="setother">
              <zyc-tooltipText :title="val"></zyc-tooltipText>
            </div>
            <zyc-progress v-if="isProgress" :percentage="i['number']"></zyc-progress>
          </td>
          <td v-else-if="key == 'id'">
            <template v-if="index < 2">
            </template>
            <template v-if="index > 2">
              {{ val }}
            </template>
          </td>
          <td v-else-if="key == 'registeredAssets'">{{ val }}</td>
          <td v-else-if="key == 'establishedTime'">{{ val }}</td>
          <td v-else-if="key == 'value'">{{ val }}</td>
        </template>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
/**
 * 排行Table
 */
export default {
  name: 'zycChartsTable',
  props: {
    data: {
      type: Array,
      default: []
    },
    isProgress: {
      type: Boolean,
      default: false
    },
    rowClick: {
      type: Function,
      default: () => {
      }
    },
    activeIndex:{
      type:Number,
      default: 0
    }
  },
  model: {},
  watch: {
    data(val) {
      if (val) {
        val.forEach(i => {
          i.isSelect = false
        })
      }
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  mounted() {

  },
  created() {
  },
  methods: {
    trClick: function (row, index) {
      console.log(row, index)
      if (row.isSelect) {
        row.isSelect = false
      } else {
        this.reSetIsSelect()
        row.isSelect = true
      }
      this.rowClick(row, index)
    },
    showLoad: function () {
      this.isLoading = true
    },
    hideLoad: function () {
      this.isLoading = false
    },
    reSetIsSelect: function () {
      this.data.forEach(i => {
        i.isSelect = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/zyc/table/chartsTable.vue